var _slicedToArray = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\slicedToArray.js");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ReactSplitter", ["react"], t) : "object" == typeof exports ? exports.ReactSplitter = t(require("react")) : e.ReactSplitter = t(e.React);
}(window, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 9);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(13)();
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return o;
    });
    var r = n(0);
    n(11);

    var i = function i(e) {
      return (e % 2 == 0 ? 2 : 3) + "px";
    },
        o = function o(e) {
      var t = e.dragging,
          n = e.pixelSize,
          _e$color = e.color,
          o = _e$color === void 0 ? "silver" : _e$color,
          _e$hoverColor = e.hoverColor,
          s = _e$hoverColor === void 0 ? "gray" : _e$hoverColor,
          _e$dragColor = e.dragColor,
          a = _e$dragColor === void 0 ? "black" : _e$dragColor,
          c = {
        "--default-splitter-line-margin": (l = n, Math.max(0, Math.floor(l / 2) - 1) + "px"),
        "--default-splitter-line-size": i(n),
        "--default-splitter-line-color": t ? a : o,
        "--default-splitter-line-hover-color": t ? a : s
      };
      var l;
      return r.createElement("div", {
        className: "default-splitter",
        style: c
      }, r.createElement("div", {
        className: "line"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        i = function i() {
      return void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r;
    },
        o = function () {
      var e = {};
      return function (t) {
        if (void 0 === e[t]) {
          var n = document.querySelector(t);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (e) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        s = [];

    function a(e) {
      for (var t = -1, n = 0; n < s.length; n++) {
        if (s[n].identifier === e) {
          t = n;
          break;
        }
      }

      return t;
    }

    function c(e, t) {
      for (var n = {}, r = [], i = 0; i < e.length; i++) {
        var o = e[i],
            c = t.base ? o[0] + t.base : o[0],
            l = n[c] || 0,
            u = "".concat(c, " ").concat(l);
        n[c] = l + 1;
        var p = a(u),
            d = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        -1 !== p ? (s[p].references++, s[p].updater(d)) : s.push({
          identifier: u,
          updater: m(d, t),
          references: 1
        }), r.push(u);
      }

      return r;
    }

    function l(e) {
      var t = document.createElement("style"),
          r = e.attributes || {};

      if (void 0 === r.nonce) {
        var i = n.nc;
        i && (r.nonce = i);
      }

      if (Object.keys(r).forEach(function (e) {
        t.setAttribute(e, r[e]);
      }), "function" == typeof e.insert) e.insert(t);else {
        var s = o(e.insert || "head");
        if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        s.appendChild(t);
      }
      return t;
    }

    var u,
        p = (u = [], function (e, t) {
      return u[e] = t, u.filter(Boolean).join("\n");
    });

    function d(e, t, n, r) {
      var i = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
      if (e.styleSheet) e.styleSheet.cssText = p(t, i);else {
        var o = document.createTextNode(i),
            s = e.childNodes;
        s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(o, s[t]) : e.appendChild(o);
      }
    }

    function f(e, t, n) {
      var r = n.css,
          i = n.media,
          o = n.sourceMap;
      if (i ? e.setAttribute("media", i) : e.removeAttribute("media"), o && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(r));
      }
    }

    var h = null,
        v = 0;

    function m(e, t) {
      var n, r, i;

      if (t.singleton) {
        var o = v++;
        n = h || (h = l(t)), r = d.bind(null, n, o, !1), i = d.bind(null, n, o, !0);
      } else n = l(t), r = f.bind(null, n, t), i = function i() {
        !function (e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(n);
      };

      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else i();
      };
    }

    e.exports = function (e, t) {
      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = i());
      var n = c(e = e || [], t);
      return function (e) {
        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
          for (var r = 0; r < n.length; r++) {
            var i = a(n[r]);
            s[i].references--;
          }

          for (var o = c(e, t), l = 0; l < n.length; l++) {
            var u = a(n[l]);
            0 === s[u].references && (s[u].updater(), s.splice(u, 1));
          }

          n = o;
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" == typeof btoa) {
              var i = (s = r, a = btoa(unescape(encodeURIComponent(JSON.stringify(s)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(c, " */")),
                  o = r.sources.map(function (e) {
                return "/*# sourceURL=".concat(r.sourceRoot || "").concat(e, " */");
              });
              return [n].concat(o).concat([i]).join("\n");
            }

            var s, a, c;
            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
        }).join("");
      }, t.i = function (e, n, r) {
        "string" == typeof e && (e = [[null, e, ""]]);
        var i = {};
        if (r) for (var o = 0; o < this.length; o++) {
          var s = this[o][0];
          null != s && (i[s] = !0);
        }

        for (var a = 0; a < e.length; a++) {
          var c = [].concat(e[a]);
          r && i[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), t.push(c));
        }
      }, t;
    };
  }, function (e, t) {}, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return _;
    });
    var r = n(0);

    function i() {
      return (i = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var o = n(7);
    var s = n(1),
        a = n.n(s),
        c = n(8),
        l = ["client", "offset", "scroll", "bounds", "margin"];

    function u(e) {
      var t = [];
      return l.forEach(function (n) {
        e[n] && t.push(n);
      }), t;
    }

    function p(e, t) {
      var n = {};

      if (t.indexOf("client") > -1 && (n.client = {
        top: e.clientTop,
        left: e.clientLeft,
        width: e.clientWidth,
        height: e.clientHeight
      }), t.indexOf("offset") > -1 && (n.offset = {
        top: e.offsetTop,
        left: e.offsetLeft,
        width: e.offsetWidth,
        height: e.offsetHeight
      }), t.indexOf("scroll") > -1 && (n.scroll = {
        top: e.scrollTop,
        left: e.scrollLeft,
        width: e.scrollWidth,
        height: e.scrollHeight
      }), t.indexOf("bounds") > -1) {
        var r = e.getBoundingClientRect();
        n.bounds = {
          top: r.top,
          right: r.right,
          bottom: r.bottom,
          left: r.left,
          width: r.width,
          height: r.height
        };
      }

      if (t.indexOf("margin") > -1) {
        var i = getComputedStyle(e);
        n.margin = {
          top: i ? parseInt(i.marginTop) : 0,
          right: i ? parseInt(i.marginRight) : 0,
          bottom: i ? parseInt(i.marginBottom) : 0,
          left: i ? parseInt(i.marginLeft) : 0
        };
      }

      return n;
    }

    function d(e) {
      return e && e.ownerDocument && e.ownerDocument.defaultView || window;
    }

    var f,
        h,
        v,
        m,
        b = (f = function f(e) {
      var t = e.measure,
          n = e.measureRef,
          r = e.contentRect;
      return (0, e.children)({
        measure: t,
        measureRef: n,
        contentRect: r
      });
    }, v = h = function (e) {
      var t, n;

      function s() {
        for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (t = e.call.apply(e, [this].concat(r)) || this).state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        }, t._animationFrameID = null, t._resizeObserver = null, t._node = null, t._window = null, t.measure = function (e) {
          var n = p(t._node, m || u(t.props));
          e && (n.entry = e[0].contentRect), t._animationFrameID = t._window.requestAnimationFrame(function () {
            null !== t._resizeObserver && (t.setState({
              contentRect: n
            }), "function" == typeof t.props.onResize && t.props.onResize(n));
          });
        }, t._handleRef = function (e) {
          null !== t._resizeObserver && null !== t._node && t._resizeObserver.unobserve(t._node), t._node = e, t._window = d(t._node);
          var n = t.props.innerRef;
          n && ("function" == typeof n ? n(t._node) : n.current = t._node), null !== t._resizeObserver && null !== t._node && t._resizeObserver.observe(t._node);
        }, t;
      }

      n = e, (t = s).prototype = Object.create(n.prototype), t.prototype.constructor = t, o(t, n);
      var a = s.prototype;
      return a.componentDidMount = function () {
        this._resizeObserver = null !== this._window && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new c.a(this.measure), null !== this._node && (this._resizeObserver.observe(this._node), "function" == typeof this.props.onResize && this.props.onResize(p(this._node, m || u(this.props))));
      }, a.componentWillUnmount = function () {
        null !== this._window && this._window.cancelAnimationFrame(this._animationFrameID), null !== this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null);
      }, a.render = function () {
        var e = this.props,
            t = (e.innerRef, e.onResize, function (e, t) {
          if (null == e) return {};
          var n,
              r,
              i = {},
              o = Object.keys(e);

          for (r = 0; r < o.length; r++) {
            n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
          }

          return i;
        }(e, ["innerRef", "onResize"]));
        return Object(r.createElement)(f, i({}, t, {
          measureRef: this._handleRef,
          measure: this.measure,
          contentRect: this.state.contentRect
        }));
      }, s;
    }(r.Component), h.propTypes = {
      client: a.a.bool,
      offset: a.a.bool,
      scroll: a.a.bool,
      bounds: a.a.bool,
      margin: a.a.bool,
      innerRef: a.a.oneOfType([a.a.object, a.a.func]),
      onResize: a.a.func
    }, v);
    b.displayName = "Measure", b.propTypes.children = a.a.func;
    var g = b,
        y = n(2);
    n(16);

    var _ = function _(e) {
      var _e$horizontal = e.horizontal,
          t = _e$horizontal === void 0 ? !1 : _e$horizontal,
          _e$initialPrimarySize = e.initialPrimarySize,
          n = _e$initialPrimarySize === void 0 ? "50%" : _e$initialPrimarySize,
          _e$minPrimarySize = e.minPrimarySize,
          i = _e$minPrimarySize === void 0 ? "0px" : _e$minPrimarySize,
          _e$minSecondarySize = e.minSecondarySize,
          o = _e$minSecondarySize === void 0 ? "0px" : _e$minSecondarySize,
          _e$splitterSize = e.splitterSize,
          s = _e$splitterSize === void 0 ? "7px" : _e$splitterSize,
          a = e.renderSplitter,
          _e$resetOnDoubleClick = e.resetOnDoubleClick,
          c = _e$resetOnDoubleClick === void 0 ? !1 : _e$resetOnDoubleClick,
          _e$defaultSplitterCol = e.defaultSplitterColors,
          l = _e$defaultSplitterCol === void 0 ? {
        color: "silver",
        hover: "gray",
        drag: "black"
      } : _e$defaultSplitterCol,
          u = e.onSplitChanged,
          p = e.onMeasuredSizesChanged,
          _r$useState = r.useState({
        height: 0,
        width: 0
      }),
          _r$useState2 = _slicedToArray(_r$useState, 2),
          d = _r$useState2[0],
          f = _r$useState2[1],
          _r$useState3 = r.useState({
        height: 0,
        width: 0
      }),
          _r$useState4 = _slicedToArray(_r$useState3, 2),
          h = _r$useState4[0],
          v = _r$useState4[1],
          _r$useState5 = r.useState({
        height: 0,
        width: 0
      }),
          _r$useState6 = _slicedToArray(_r$useState5, 2),
          m = _r$useState6[0],
          b = _r$useState6[1],
          _ = r.useMemo(function () {
        return t ? d.height : d.width;
      }, [t, d]),
          w = r.useMemo(function () {
        return t ? h.height : h.width;
      }, [t, h]),
          O = r.useMemo(function () {
        return t ? m.height : m.width;
      }, [t, m]),
          _r$useState7 = r.useState(void 0),
          _r$useState8 = _slicedToArray(_r$useState7, 2),
          x = _r$useState8[0],
          E = _r$useState8[1],
          _r$useState9 = r.useState(0),
          _r$useState10 = _slicedToArray(_r$useState9, 2),
          z = _r$useState10[0],
          R = _r$useState10[1],
          _r$useState11 = r.useState(0),
          _r$useState12 = _slicedToArray(_r$useState11, 2),
          T = _r$useState12[0],
          S = _r$useState12[1],
          _r$useState13 = r.useState(!1),
          _r$useState14 = _slicedToArray(_r$useState13, 2),
          M = _r$useState14[0],
          j = _r$useState14[1];

      r.useEffect(function () {
        u && u(void 0 !== x ? x + "%" : n);
      }, [x, n]), r.useEffect(function () {
        p && p({
          primary: w,
          splitter: O,
          secondary: _ - (w + O)
        });
      }, [t, _, w, O]);

      var C = function C(e) {
        e.bounds && v({
          height: e.bounds.height,
          width: e.bounds.width
        });
      },
          A = function A(e) {
        e.bounds && b({
          height: e.bounds.height,
          width: e.bounds.width
        });
      },
          P = function P(e) {
        e.currentTarget.setPointerCapture(e.pointerId), R(t ? e.clientY : e.clientX), S(w), j(!0);
      },
          k = function k(e) {
        if (e.currentTarget.hasPointerCapture(e.pointerId)) {
          var _n = t ? e.clientY : e.clientX,
              _r = T + (_n - z),
              _i = Math.max(0, Math.min(_r, _));

          E(_i / _ * 100);
        }
      },
          D = function D(e) {
        e.currentTarget.releasePointerCapture(e.pointerId), j(!1);
      },
          I = function I() {
        c && E(void 0);
      },
          N = r.Children.toArray(e.children),
          L = N.length > 0 ? N[0] : r.createElement("div", null),
          W = N.length > 1 ? N[1] : r.createElement("div", null),
          F = {
        primary: void 0 !== x ? x + "%" : n,
        minPrimary: null != i ? i : "0px",
        minSecondary: null != o ? o : "0px"
      },
          q = {
        pixelSize: O,
        horizontal: t,
        dragging: M
      },
          B = null != a ? a : function () {
        return r.createElement(y.a, Object.assign({}, q, {
          color: M ? l.drag : l.color,
          hoverColor: M ? l.drag : l.hover
        }));
      },
          H = t ? "split-container horizontal" : "split-container vertical",
          U = {
        "--react-split-min-primary": F.minPrimary,
        "--react-split-min-secondary": F.minSecondary,
        "--react-split-primary": F.primary,
        "--react-split-splitter": s
      };

      return r.createElement(g, {
        bounds: !0,
        onResize: function onResize(e) {
          e.bounds && f({
            height: e.bounds.height,
            width: e.bounds.width
          });
        }
      }, function (_ref) {
        var e = _ref.measureRef;
        return r.createElement("div", {
          className: "react-split",
          ref: e
        }, r.createElement("div", {
          className: H,
          style: U
        }, r.createElement("div", {
          className: "primary"
        }, r.createElement(g, {
          bounds: !0,
          onResize: C
        }, function (_ref2) {
          var e = _ref2.measureRef;
          return r.createElement("div", {
            className: "full-content",
            ref: e
          }, L);
        })), r.createElement("div", {
          className: "splitter",
          tabIndex: -1,
          onPointerDown: P,
          onPointerUp: D,
          onPointerMove: k,
          onDoubleClick: I
        }, r.createElement(g, {
          bounds: !0,
          onResize: A
        }, function (_ref3) {
          var e = _ref3.measureRef;
          return r.createElement("div", {
            className: "full-content",
            ref: e
          }, B(q));
        })), r.createElement("div", {
          className: "secondary"
        }, r.createElement("div", {
          className: "full-content"
        }, W))));
      });
    };
  }, function (e, t) {
    function n(t, r) {
      return e.exports = n = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0, n(t, r);
    }

    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var n = function () {
        if ("undefined" != typeof Map) return Map;

        function e(e, t) {
          var n = -1;
          return e.some(function (e, r) {
            return e[0] === t && (n = r, !0);
          }), n;
        }

        return function () {
          function t() {
            this.__entries__ = [];
          }

          return Object.defineProperty(t.prototype, "size", {
            get: function get() {
              return this.__entries__.length;
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.get = function (t) {
            var n = e(this.__entries__, t),
                r = this.__entries__[n];
            return r && r[1];
          }, t.prototype.set = function (t, n) {
            var r = e(this.__entries__, t);
            ~r ? this.__entries__[r][1] = n : this.__entries__.push([t, n]);
          }, t.prototype.delete = function (t) {
            var n = this.__entries__,
                r = e(n, t);
            ~r && n.splice(r, 1);
          }, t.prototype.has = function (t) {
            return !!~e(this.__entries__, t);
          }, t.prototype.clear = function () {
            this.__entries__.splice(0);
          }, t.prototype.forEach = function (e, t) {
            void 0 === t && (t = null);

            for (var n = 0, r = this.__entries__; n < r.length; n++) {
              var i = r[n];
              e.call(t, i[1], i[0]);
            }
          }, t;
        }();
      }(),
          r = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
          i = void 0 !== e && e.Math === Math ? e : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
          o = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(i) : function (e) {
        return setTimeout(function () {
          return e(Date.now());
        }, 1e3 / 60);
      };

      var s = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
          a = "undefined" != typeof MutationObserver,
          c = function () {
        function e() {
          this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, t) {
            var n = !1,
                r = !1,
                i = 0;

            function s() {
              n && (n = !1, e()), r && c();
            }

            function a() {
              o(s);
            }

            function c() {
              var e = Date.now();

              if (n) {
                if (e - i < 2) return;
                r = !0;
              } else n = !0, r = !1, setTimeout(a, t);

              i = e;
            }

            return c;
          }(this.refresh.bind(this), 20);
        }

        return e.prototype.addObserver = function (e) {
          ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
        }, e.prototype.removeObserver = function (e) {
          var t = this.observers_,
              n = t.indexOf(e);
          ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_();
        }, e.prototype.refresh = function () {
          this.updateObservers_() && this.refresh();
        }, e.prototype.updateObservers_ = function () {
          var e = this.observers_.filter(function (e) {
            return e.gatherActive(), e.hasActive();
          });
          return e.forEach(function (e) {
            return e.broadcastActive();
          }), e.length > 0;
        }, e.prototype.connect_ = function () {
          r && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), a ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
            attributes: !0,
            childList: !0,
            characterData: !0,
            subtree: !0
          })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
        }, e.prototype.disconnect_ = function () {
          r && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
        }, e.prototype.onTransitionEnd_ = function (e) {
          var t = e.propertyName,
              n = void 0 === t ? "" : t;
          s.some(function (e) {
            return !!~n.indexOf(e);
          }) && this.refresh();
        }, e.getInstance = function () {
          return this.instance_ || (this.instance_ = new e()), this.instance_;
        }, e.instance_ = null, e;
      }(),
          l = function l(e, t) {
        for (var n = 0, r = Object.keys(t); n < r.length; n++) {
          var i = r[n];
          Object.defineProperty(e, i, {
            value: t[i],
            enumerable: !1,
            writable: !1,
            configurable: !0
          });
        }

        return e;
      },
          u = function u(e) {
        return e && e.ownerDocument && e.ownerDocument.defaultView || i;
      },
          p = b(0, 0, 0, 0);

      function d(e) {
        return parseFloat(e) || 0;
      }

      function f(e) {
        for (var t = [], n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }

        return t.reduce(function (t, n) {
          return t + d(e["border-" + n + "-width"]);
        }, 0);
      }

      function h(e) {
        var t = e.clientWidth,
            n = e.clientHeight;
        if (!t && !n) return p;

        var r = u(e).getComputedStyle(e),
            i = function (e) {
          for (var t = {}, n = 0, r = ["top", "right", "bottom", "left"]; n < r.length; n++) {
            var i = r[n],
                o = e["padding-" + i];
            t[i] = d(o);
          }

          return t;
        }(r),
            o = i.left + i.right,
            s = i.top + i.bottom,
            a = d(r.width),
            c = d(r.height);

        if ("border-box" === r.boxSizing && (Math.round(a + o) !== t && (a -= f(r, "left", "right") + o), Math.round(c + s) !== n && (c -= f(r, "top", "bottom") + s)), !function (e) {
          return e === u(e).document.documentElement;
        }(e)) {
          var l = Math.round(a + o) - t,
              h = Math.round(c + s) - n;
          1 !== Math.abs(l) && (a -= l), 1 !== Math.abs(h) && (c -= h);
        }

        return b(i.left, i.top, a, c);
      }

      var v = "undefined" != typeof SVGGraphicsElement ? function (e) {
        return e instanceof u(e).SVGGraphicsElement;
      } : function (e) {
        return e instanceof u(e).SVGElement && "function" == typeof e.getBBox;
      };

      function m(e) {
        return r ? v(e) ? function (e) {
          var t = e.getBBox();
          return b(0, 0, t.width, t.height);
        }(e) : h(e) : p;
      }

      function b(e, t, n, r) {
        return {
          x: e,
          y: t,
          width: n,
          height: r
        };
      }

      var g = function () {
        function e(e) {
          this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = b(0, 0, 0, 0), this.target = e;
        }

        return e.prototype.isActive = function () {
          var e = m(this.target);
          return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
        }, e.prototype.broadcastRect = function () {
          var e = this.contentRect_;
          return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
        }, e;
      }(),
          y = function y(e, t) {
        var n,
            r,
            i,
            o,
            s,
            a,
            c,
            u = (r = (n = t).x, i = n.y, o = n.width, s = n.height, a = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, c = Object.create(a.prototype), l(c, {
          x: r,
          y: i,
          width: o,
          height: s,
          top: i,
          right: r + o,
          bottom: s + i,
          left: r
        }), c);
        l(this, {
          target: e,
          contentRect: u
        });
      },
          _ = function () {
        function e(e, t, r) {
          if (this.activeObservations_ = [], this.observations_ = new n(), "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
          this.callback_ = e, this.controller_ = t, this.callbackCtx_ = r;
        }

        return e.prototype.observe = function (e) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(e instanceof u(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var t = this.observations_;
            t.has(e) || (t.set(e, new g(e)), this.controller_.addObserver(this), this.controller_.refresh());
          }
        }, e.prototype.unobserve = function (e) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(e instanceof u(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var t = this.observations_;
            t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
          }
        }, e.prototype.disconnect = function () {
          this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
        }, e.prototype.gatherActive = function () {
          var e = this;
          this.clearActive(), this.observations_.forEach(function (t) {
            t.isActive() && e.activeObservations_.push(t);
          });
        }, e.prototype.broadcastActive = function () {
          if (this.hasActive()) {
            var e = this.callbackCtx_,
                t = this.activeObservations_.map(function (e) {
              return new y(e.target, e.broadcastRect());
            });
            this.callback_.call(e, t, e), this.clearActive();
          }
        }, e.prototype.clearActive = function () {
          this.activeObservations_.splice(0);
        }, e.prototype.hasActive = function () {
          return this.activeObservations_.length > 0;
        }, e;
      }(),
          w = "undefined" != typeof WeakMap ? new WeakMap() : new n(),
          O = function e(t) {
        if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var n = c.getInstance(),
            r = new _(t, n, this);
        w.set(this, r);
      };

      ["observe", "unobserve", "disconnect"].forEach(function (e) {
        O.prototype[e] = function () {
          var t;
          return (t = w.get(this))[e].apply(t, arguments);
        };
      });
      var x = void 0 !== i.ResizeObserver ? i.ResizeObserver : O;
      t.a = x;
    }).call(this, n(15));
  }, function (e, t, n) {
    e.exports = n(10);
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(2);
    n.d(t, "DefaultSplitter", function () {
      return r.a;
    });
    var i = n(5);

    for (var o in i) {
      ["default", "DefaultSplitter"].indexOf(o) < 0 && function (e) {
        n.d(t, e, function () {
          return i[e];
        });
      }(o);
    }

    var s = n(6);
    n.d(t, "Split", function () {
      return s.a;
    });
  }, function (e, t, n) {
    var r = n(3),
        i = n(12);
    "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(i, o);
    e.exports = i.locals || {};
  }, function (e, t, n) {
    (t = n(4)(!1)).push([e.i, "\r\n/* The default splitter within a react-split */\r\n.react-split > .split-container > .splitter .default-splitter {\r\n  box-sizing: border-box;\r\n  height: 100%;\r\n  outline: none;\r\n  overflow: hidden;\r\n  user-select: none;\r\n  width: 100%;\r\n  --default-splitter-line-color: silver;\r\n  --default-splitter-line-hover-color: black;\r\n  --default-splitter-line-margin: 2px;\r\n  --default-splitter-line-size: 3px;\r\n}\r\n\r\n.react-split > .split-container.horizontal > .splitter .default-splitter {\r\n  cursor: row-resize;\r\n}\r\n\r\n.react-split > .split-container.vertical > .splitter .default-splitter {\r\n  cursor: col-resize;\r\n}\r\n\r\n/* The thin line within a default splitter hit area */\r\n.react-split > .split-container > .splitter .default-splitter > .line {\r\n  background: var(--default-splitter-line-color);\r\n}\r\n\r\n.react-split > .split-container > .splitter .default-splitter:hover > .line {\r\n  background: var(--default-splitter-line-hover-color);\r\n}\r\n\r\n.react-split > .split-container.horizontal > .splitter .default-splitter > .line {\r\n  height: var(--default-splitter-line-size);\r\n  width: 100%;\r\n  margin-top: var(--default-splitter-line-margin);\r\n  margin-left: 0;\r\n}\r\n\r\n.react-split > .split-container.vertical > .splitter .default-splitter > .line {\r\n  height: 100%;\r\n  width: var(--default-splitter-line-size);\r\n  margin-top: 0;\r\n  margin-left: var(--default-splitter-line-margin);\r\n}", ""]), e.exports = t;
  }, function (e, t, n) {
    "use strict";

    var r = n(14);

    function i() {}

    function o() {}

    o.resetWarningCache = i, e.exports = function () {
      function e(e, t, n, i, o, s) {
        if (s !== r) {
          var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw a.name = "Invariant Violation", a;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: o,
        resetWarningCache: i
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(3),
        i = n(17);
    "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(i, o);
    e.exports = i.locals || {};
  }, function (e, t, n) {
    (t = n(4)(!1)).push([e.i, '/* The top-level element of the splitter*/\r\n.react-split {\r\n  width: 100%;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  overflow: hidden;\r\n  --react-split-min-primary: 0;\r\n  --react-split-min-secondary: 0;\r\n  --react-split-primary: 50%;\r\n  --react-split-splitter: 7px;\r\n}\r\n\r\n/* The container for the primary pane, splitter, and secondary pane.*/\r\n.react-split > .split-container {\r\n  width: 100%;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  overflow: hidden;\r\n  display: grid;\r\n}\r\n\r\n/* When the container is splitting horizontally */\r\n.react-split > .split-container.horizontal {\r\n  grid-template-columns: 1fr;\r\n  grid-template-rows: minmax(var(--react-split-min-primary),var(--react-split-primary)) var(--react-split-splitter) minmax(var(--react-split-min-secondary), 1fr);\r\n  grid-template-areas: "primary" "split" "secondary";\r\n}\r\n\r\n/* When the container is splitting vertical */\r\n.react-split > .split-container.vertical {\r\n  grid-template-columns: minmax(var(--react-split-min-primary),var(--react-split-primary)) var(--react-split-splitter) minmax(var(--react-split-min-secondary), 1fr);\r\n  grid-template-rows: 1fr;\r\n  grid-template-areas: "primary split secondary";\r\n}\r\n\r\n/* The primary pane. This is either the left or top depending on the split type */\r\n.react-split > .split-container > .primary {\r\n  grid-area: primary;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  overflow: hidden;\r\n}\r\n\r\n.react-split > .split-container.horizontal > .primary {\r\n  height: auto;\r\n  width: 100%;\r\n}\r\n\r\n.react-split > .split-container.vertical > .primary {\r\n  height: 100%;\r\n  width: auto;\r\n}\r\n\r\n/* The splitter between panes. */\r\n.react-split > .split-container > .splitter {\r\n  grid-area: split;\r\n  background: transparent;\r\n  user-select: none;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  overflow: hidden;\r\n}\r\n\r\n.react-split > .split-container.horizontal > .splitter {\r\n  height: auto;\r\n  width: 100%;\r\n  cursor: row-resize;\r\n}\r\n\r\n.react-split > .split-container.vertical > .splitter {\r\n  height: 100%;\r\n  width: auto;\r\n  cursor: col-resize;\r\n}\r\n\r\n/* The secondary pane. This is either the right or bottom depending on the split type */\r\n.react-split > .split-container >.secondary {\r\n  grid-area: secondary;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  overflow: hidden;\r\n}\r\n\r\n.react-split > .split-container.horizontal > .secondary {\r\n  height: auto;\r\n  width: 100%;\r\n}\r\n\r\n.react-split > .split-container.vertical > .secondary {\r\n  height: 100%;\r\n  width: auto;\r\n}\r\n\r\n/* The content within the primary pane, splitter, or secondary pane.*/\r\n.react-split .full-content {\r\n  width: 100%;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  overflow: hidden;\r\n}\r\n', ""]), e.exports = t;
  }]);
});